/* eslint-disable */
import { mapState, mapMutations } from 'vuex';

export const baseVolumeValue = 90;
let audio;
let uuid;

export const prefixCls = 'vue-sound';

export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx'.replace(/[xy]/g, function (c) {
    let v, r;
    r = Math.random() * 16 | 0; v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

export const convertTimeHHMMSS = (val) => {
  let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);
  return (hhmmss.indexOf('00:') === 0) ? hhmmss.substr(3) : hhmmss;
};

export default {
  name: 'vue-audio',
  props: {
    file: {
      type: String,
      default: null,
    },
    autoPlay: {
      type: Boolean,
      default: false,
    },
    loop: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['selected', 'tagClick']),
    versionId() {
      return this.$route.params.vid;
    },
    sutraId() {
      return this.$route.params.sid;
    },
    mp3List() {
      return this.$store.state.mp3List;
    },
    duration: function () {
      return this.audio ? convertTimeHHMMSS(this.totalDuration) : '';
    },
    playerId: function () {
      return 'player-' + this.uuid;
    },
    classes: function () {
      return prefixCls;
    }
  },
  data () {
    return {
      isMuted: false,
      loaded: false,
      playing: false,
      paused: true,
      progressStyle: '',
      currentTime: '00:00',
      uuid: '0',
      innerLoop: undefined,
      audio: undefined,
      totalDuration: 0,
      hideVolumeSlider: false,
      volumeValue: baseVolumeValue,
    };
  },
  methods: {
    ...mapMutations(['updateTagClick']),
    clickTagPlay(startTime) {
      this.audio.currentTime = startTime;
      this.play();
    },
    setPosition: function name (e) {

      let tag = e.target;
      if (e.target.tagName === 'SPAN') {
        return;
      }
      const pos = tag.getBoundingClientRect()

      const seekPos = (e.clientX - pos.left) / pos.width;
      this.audio.currentTime = parseInt(this.audio.duration * seekPos);

      if (this.paused) {
        this.pause();
      };

    },
    updateVolume: function () {
      this.hideVolumeSlider = false;
      this.audio.volume = this.volumeValue / 100;
      if (this.volumeValue / 100 > 0) {
        this.isMuted = this.audio.muted = false;
      }

      if (this.volumeValue / 100 === 0) {
        this.isMuted = this.audio.muted = true;
      }
    },
    toggleVolume: function () {
      this.hideVolumeSlider = true;
    },
    stop: function () {
      this.playing = false;
      this.paused = true;
      this.audio.pause();
      this.audio.currentTime = 0;
    },
    play: function () {
      if (this.playing && !this.paused) return;
      this.paused = false;
      this.audio.play();
      this.playing = true;
    },
    pause: function () {
      this.paused = !this.paused;
      (this.paused) ? this.audio.pause() : this.audio.play();
    },
    changeLoop: function () {
      this.innerLoop = !this.innerLoop;
    },
    download: function () {
      this.stop()
      window.open(this.file, 'download');
    },
    mute: function () {
      this.isMuted = !this.isMuted;
      this.audio.muted = this.isMuted;
      this.volumeValue = this.isMuted ? 0 : 75;
    },
    _handleLoaded: function () {
      if (this.audio.readyState >= 2) {
        if (this.autoPlay) this.play();

        this.loaded = true;
        this.totalDuration = parseInt(this.audio.duration);
      } else {
        throw new Error('Failed to load sound file');
      }
    },
    _handlePlayingUI: function (e) {

      let currTime = parseInt(this.audio.currentTime);
      let percentage = parseInt((currTime / this.totalDuration) * 100);
      this.progressStyle = `width:${percentage}%;`;


      this.currentTime = convertTimeHHMMSS(currTime);
    },
    _handlePlayPause: function (e) {
      if (e.type === 'pause' && this.playing === false) {
        this.paused = true;
      }
    },
    init: function () {
      this.audio.addEventListener('timeupdate', this._handlePlayingUI);
      this.audio.addEventListener('loadeddata', this._handleLoaded);
      this.audio.addEventListener('pause', this._handlePlayPause);
      this.audio.addEventListener('play', this._handlePlayPause);
    },
    getAudio: function () {
      return this.$el.querySelectorAll('audio')[0];
    }
  },
  mounted: function () {
    this.$store.dispatch('getMp3List');
    this.uuid = generateUUID();
    this.audio = this.getAudio();
    this.innerLoop = this.loop;
    this.init();
  },
  watch: {
    tagClick: function() {
      let mp3fileName = 'v' + this.versionId + 's' + this.sutraId + 'to2';

      if(this.mp3List.filter(item => item.mp3 == mp3fileName).length !== 0){

        let timeContent = this.mp3List.filter(item => item.mp3 == mp3fileName)[0].timeContent || null;

        timeContent = timeContent.filter(item => item.tag == this.selected);

        if (timeContent.length && timeContent[0] !== undefined) {

        const startTime = timeContent[0].start;

        this.clickTagPlay(startTime);

        }
      }
    },
  },
  beforeDestroy: function () {
    this.audio.removeEventListener('timeupdate', this._handlePlayingUI);
    this.audio.removeEventListener('loadeddata', this._handleLoaded);
    this.audio.removeEventListener('pause', this._handlePlayPause);
    this.audio.removeEventListener('play', this._handlePlayPause);
  },

};



// WEBPACK FOOTER //
// ./src/components/Audio/vueaudio.plugin.js